export const ClearTrackServiceBaseUrl  = 'https://api.qa.cleartrack.warnerbros.com';
export const clearTrackServiceWSBaseUrl = 'wss://unshmq9z8i.execute-api.us-west-2.amazonaws.com/qa';
export const OKTA_CLIENT_ID = "0oa1cfqok55j785e90h8";
export const OKTA_ISSUER_URL = "https://ssobizqa.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://ssobizqa.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";